export default "__VITE_ASSET__zz5v5hFB__"